<div class="container col-lg-12 mb-3">
    <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0 ml-2"  style="font-size: 15px; color: #2F2B3DE5">Projets</h5>
        <button class="btn btn-primary" (click)="openAjoutModal()" > + Ajouter</button>
    </div>
</div>

<div >
    <div class="table-responsive">
        <table class="table table-hover">
            <thead class=" align-middle custom-thead">
            <tr >
                <th>Nom</th>
                <th>État</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let project of projects">
                <td>{{ project.libelle }}</td>

                <td>
                    <div class="custom-control custom-switch custom-control-success">

                        <input
                                type="checkbox"
                                class="custom-control-input"
                                [checked]="project.statut"
                                (click)="openArchiveModal(modalVC, project); $event.preventDefault();"
                                [id]="'switch-' + project.id"
                        />
                        <label class="custom-control-label"
                               [for]="'switch-' + project.id">

                        </label>
                    </div>

                </td>
                <td class="">
                    <button class="unstyled-btn btn-sm" (click)="openEditModal(project); $event.preventDefault();">
                        <i data-feather="edit"  [size]="22" class="feather-icon icon-15"></i>
                    </button>


                </td>

           <!--     <ng-template #modalVC let-modal class="custom-centered-modal">
                    <div>

                        <button type="button" class="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" tabindex="0" ngbAutofocus>

                        <h4> Désactivation projet </h4>
                        <p>  Êtes-vous sûr de vouloir désactiver le projet X ?
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" rippleEffect>
                            Confirmer
                        </button>
                        <button type="button" class="btn btn-secondary" (click)="modal.close('Accept click')" rippleEffect>
                            Annuler
                        </button>
                    </div>
                </ng-template>-->
                <ng-template #modalVC let-modal class="custom-centered-modal">
                    <div class="modal-header p-0" style="background-color: transparent;">
                        <button type="button" class=" close" style="margin-right: 5px"
                                (click)="modal.dismiss('Cross click')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="card-body d-flex flex-column" style="min-height: 150px;padding:53px 64px 64px 64px">
                        <div class="flex-grow-1 overflow-auto pe-1">
                            <h4 style="font-size: 24px ; text-align: center"> {{ pendingStatus ? 'Activation' : 'Désactivation' }} projet </h4>
                            <p class="text-muted text-center m-0" >
                                Êtes-vous sûr de vouloir
                                {{ pendingStatus ? 'activer' : 'désactiver' }}
                                le projet <strong>{{ selectedProject?.libelle }}</strong> ?
                            </p>
                        </div>

                    <div class="pt-2 d-flex justify-content-center" style="gap: 16px">
                        <button type="button" class="btn btn-primary" (click)="confirmStatusChange(modal)"
                        >Confirmer
                        </button>
                        <button type="button" class="btn btn-grey" (click)="modal.close('Accept click')">
                            Annuler
                        </button>
                    </div>
                    </div>
                </ng-template>


            </tr>
            </tbody>

        </table>
    </div>
</div>

<app-ajout-projet  #projectModal
                   [clientId]="clientId"
                   [stationId]="stationId"
                   (projectSaved)="onProjectSaved()"
                   #ajout></app-ajout-projet>
